import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import makeCarousel from 'react-reveal/makeCarousel'
import { Flex, Box } from '@rebass/emotion'
import { COLORS, FONT_SIZES, SPACERS } from 'utils/styleHelpers'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
const Container = styled(Flex)`
	overflow: hidden;
	width: ${({ width }) => width}px;
	margin: 0;
`
const Children = styled.div`
	width: ${({ width }) => width}px;
	position: relative;
	height: ${({ height }) => height}px;
`
const Arrow = styled.div`
	text-shadow: 1px 1px 1px #fff;
	z-index: 100;
	line-height: ${({ height }) => height}px;
	position: absolute;
	top: 0;
	width: 10%;
	font-size: 3em;
	cursor: pointer;
	user-select: none;
	left: ${({ right }) => (right ? `90%` : `0%`)};
`
const Dot = styled(Box)`
	font-size: ${FONT_SIZES.H4};
	padding-left: ${SPACERS.S};
	padding-right: ${SPACERS.S};
	cursor: pointer;
	text-shadow: 1px 1px 1px #fff;
	user-select: none;
	color: ${({ index, position }) => (index === position ? COLORS.GREEN : COLORS.MEDIUM_LIGHT_GRAY)};
	transition: text-shadow 0.5s;
	.dark & {
		text-shadow: 1px 1px 1px ${COLORS.MEDIUM_GRAY};
	}
`
const Dots = styled(Box)`
	width: ${({ width }) => width}px;
	z-index: 100;
	text-align: center;
`
const ForwardArrow = styled(IoIosArrowForward)`
	color: ${COLORS.MEDIUM_LIGHT_GRAY};
`
const BackArrow = styled(IoIosArrowBack)`
	color: ${COLORS.MEDIUM_LIGHT_GRAY};
`

const CarouselUI = ({ position, total, handleClick, children, height, width }) => {
	return (
		<Container width={width} height={height} justifyContent="center" alignItems="center" flexDirection="column">
			<Dots alignSelf="center">
				<Flex flexDirection="row" justifyContent="center">
					{Array(...Array(total)).map((val, index) => (
						<Dot key={index} onClick={handleClick} data-position={index} index={index} position={position}>
							{'●'}
						</Dot>
					))}
				</Flex>
			</Dots>
			<Children width={width} height={height}>
				{children}
				<Arrow
					onClick={handleClick}
					data-position={!isNaN(position) ? position - 1 : 0}
					width={width}
					height={height}
				>
					<Flex justifyContent="center">
						<Box>
							<BackArrow />
						</Box>
					</Flex>
				</Arrow>
				<Arrow
					right
					onClick={handleClick}
					data-position={!isNaN(position) ? position + 1 : 0}
					width={width}
					height={height}
				>
					<Flex justifyContent="center">
						<Box>
							<ForwardArrow />
						</Box>
					</Flex>
				</Arrow>
			</Children>
		</Container>
	)
}

CarouselUI.propTypes = {
	position: PropTypes.number,
	total: PropTypes.number,
	handleClick: PropTypes.func,
	children: PropTypes.array,
	width: PropTypes.number,
	height: PropTypes.number,
}

const HomeRevealCarousel = makeCarousel(CarouselUI)

function Carousel({ children, defaultWait = 2000, width = 330, height = 460 }) {
	const [uiWidth, setUiWidth] = useState(0)
	const [uiHeight, setUiHeight] = useState(0)
	const [waitTime, setWaitTime] = useState(2000)
	useEffect(() => {
		setUiHeight(height)
		setUiWidth(width)
		setWaitTime(defaultWait)
	}, [width, height, defaultWait])
	return (
		<HomeRevealCarousel height={uiHeight} width={uiWidth} defaultWait={waitTime}>
			{children}
		</HomeRevealCarousel>
	)
}
Carousel.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	defaultWait: PropTypes.number,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]),
}

export default Carousel
